import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AlertModal from 'components/common-components/AlertModal';
import DateTimePickerDropdown from 'components/common-components/DateTimePickerDropdown';
import FormButton from 'components/form-components/FormButton';
import { CallAPI } from 'actions/General';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

const DuplicateTaskModal = ({ duplicatedTask, setDuplicatedTask, refreshList, isNestedModal }) => {
  const { t } = useTranslation();

  const [values, setValues] = useState({
    startDate: duplicatedTask.startDate,
    endDate: duplicatedTask.endDate,
  });

  const handleChange = (field, value) => {
    setValues((prevValues) => ({ ...prevValues, [field]: value }));
  };

  const isValid = () => {
    if (values.startDate && values.endDate) {
      const now = new Date();
      const startDate = new Date(values.startDate);
      const endDate = new Date(values.endDate);
      if (startDate <= now) {
        toast.error('Start date must be later than the current date and time');
        return false;
      }
      if (endDate <= startDate) {
        toast.error('End date must be later than the start date');
        return false;
      }
    }

    return true;
  };

  const duplicateAction = async () => {
    if (!isValid()) return;

    const payload = {
      scheduleId: duplicatedTask.scheduleId,
      taskId: duplicatedTask._id,
      startDate: values.startDate,
      endDate: values.endDate,
    };
    const result = await CallAPI('DUPLICATE_TASK', payload);
    if (result.status) {
      refreshList();
    }
  };

  return (
    <AlertModal
      show={true}
      size='md'
      actionButtons={[]}
      enforceFocus={false}
      backdropClassName={isNestedModal ? 'backdrop-overlap' : ''}
    >
      <div className='w-100'>
        <div className='mb-3'>
          <label className='theme-size-1_2'>{t('text_duplicating_task')}</label>
        </div>
        <div className='row align-items-center mb-3'>
          <div className='col-5 d-flex flex-column'>
            <span className='theme-font-inter-semi-bold theme-text-black-1'>
              {t('field_starts_at')}
            </span>
          </div>
          <div className='col-7'>
            <DateTimePickerDropdown
              name='startDate'
              value={values.startDate}
              onChange={handleChange}
              format12Hour
              defaultTime='startOfDay'
              zIndex={1055}
            />
          </div>
        </div>

        <div className='row align-items-center mb-4'>
          <div className='col-5 d-flex flex-column'>
            <span className='theme-font-inter-semi-bold theme-text-black-1'>
              {t('field_ends_at')}
            </span>
          </div>
          <div className='col-7'>
            <DateTimePickerDropdown
              name='endDate'
              value={values.endDate}
              onChange={handleChange}
              format12Hour
              defaultTime='startOfDay'
              zIndex={1055}
            />
          </div>
        </div>
        <div className='d-flex gap-3 justify-content-end'>
          <FormButton
            text={'button_discard'}
            variant='white-1'
            onClick={() => setDuplicatedTask(null)}
            minWidth
          />
          <FormButton
            text={'button_duplicate'}
            variant='green-1'
            onClick={duplicateAction}
            minWidth
          />
        </div>
      </div>
    </AlertModal>
  );
};

DuplicateTaskModal.propTypes = {
  duplicatedTask: PropTypes.object.isRequired,
  setDuplicatedTask: PropTypes.func.isRequired,
  refreshList: PropTypes.func.isRequired,
  isNestedModal: PropTypes.bool,
};

export default DuplicateTaskModal;
